import serviceIconSVG from '../../assets/icons/service-color.svg';
import { CoreIcon } from '../core-icon';

import type { IconProps } from '../core-icon';

export const ServiceColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={serviceIconSVG} {...props} />;
};
